var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.568,
    height: 41.569,
    viewBox: "0 0 41.568 41.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M1155.005,387.235a20.784,20.784,0,1,0,20.784,20.784A20.807,20.807,0,0,0,1155.005,387.235Zm0,38.9a18.118,18.118,0,1,1,18.119-18.119A18.139,18.139,0,0,1,1155.005,426.138Z",
    transform: "translate(-1134.222 -387.235)",
    fill: "#17447e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M1174.022,416.435a2.585,2.585,0,0,0-4.381-1.861,12.663,12.663,0,0,0-6.918-2.195l1.179-5.544,3.849.819a1.851,1.851,0,1,0,.189-.9l-4.3-.914a.462.462,0,0,0-.548.356l-1.316,6.186a12.706,12.706,0,0,0-7.02,2.192,2.585,2.585,0,1,0-2.847,4.224,5.114,5.114,0,0,0-.062.783c0,3.98,4.632,7.206,10.347,7.206s10.347-3.226,10.347-7.206a5.11,5.11,0,0,0-.061-.778A2.585,2.585,0,0,0,1174.022,416.435Zm-17.735,1.848a1.848,1.848,0,1,1,1.848,1.848A1.85,1.85,0,0,1,1156.287,418.283Zm10.3,4.882c-1.261,1.26-3.678,1.357-4.388,1.357s-3.127-.1-4.387-1.357a.479.479,0,0,1,.677-.677,6.93,6.93,0,0,0,7.421,0,.479.479,0,1,1,.677.677Zm-.325-3.034a1.848,1.848,0,1,1,1.848-1.848A1.85,1.85,0,0,1,1166.265,420.131Z",
    transform: "translate(-1141.419 -395.466)",
    fill: "#17447e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.4bd7c40cebb5e3a4a8b144005a427b06.svg";
export { ForwardRef as ReactComponent };